module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', {
    staticClass: "creative-preview-wrapper"
  }, [_c('div', {
    staticClass: "creative-preview"
  }, [(!_vm.isInCreativeView) ? _c('gotu-nav-button', {
    staticClass: "historyBtn",
    attrs: {
      "iconLeft": "clock-o",
      "theme": "default-cta"
    },
    on: {
      "click": function($event) {
        _vm.goToCreative(_vm.creative.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.creative-preview.show-history')))]) : _vm._e(), _c('campaign-creative', {
    attrs: {
      "creative": _vm.creative,
      "facebookPage": _vm.facebookPage,
      "disabledButtons": _vm.disabledButtons,
      "mobilePreview": _vm.internalMobilePreview,
      "usePortal": _vm.usePortal,
      "enableFormPreview": _vm.enableFormPreview
    }
  }), (_vm.canUpdateBriefStatus && _vm.isInCreativeView) ? _c('creative-preview-feedback', {
    attrs: {
      "permissions": _vm.permissions
    },
    on: {
      "approveCreative": function($event) {
        _vm.finish(false)
      }
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a770f3a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/creative-preview-wrapper/CreativePreviewWrapper.vue
// module id = 2059
// module chunks = 1